// Fonte ÚNICA de metadados dos mapas: o client constrói geometria a partir daqui,
// o server faz seed do banco a partir daqui. authorMs PROVISÓRIOS até playtest.
import { deriveMedals, MedalTimes } from './medals';

/** Ambiente visual (céu/fog/luz/hazard) — implementado em client/render/scene. */
export type EnvId = 'island' | 'dusk' | 'night' | 'space' | 'lava';

export interface MapMeta {
  slug: string;
  name: string;
  tier: number;
  stages: number;
  authorMs: number;
  env: EnvId;
  /** hazard visível no fundo do mapa (a morte é o killY de sempre) */
  hazard?: 'water' | 'lava' | 'void';
  credit?: string;
  sortOrder: number;
}

export const MAPS_META: MapMeta[] = [
  {
    slug: 'surf_academia', name: 'surf_academia', tier: 1, stages: 4, authorMs: 55000,
    env: 'island', hazard: 'water', sortOrder: 1,
  },
  {
    slug: 'surf_beginner', name: 'surf_beginner', tier: 1, stages: 4, authorMs: 60000,
    env: 'dusk', hazard: 'void', sortOrder: 2,
    credit: 'Recriação livre do clássico de CS:S — geometria reconstruída do zero',
  },
  {
    slug: 'surf_utopia', name: 'surf_utopia', tier: 2, stages: 4, authorMs: 70000,
    env: 'night', hazard: 'void', sortOrder: 3,
    credit: 'Recriação livre do icônico de CS:S — geometria reconstruída do zero',
  },
  {
    slug: 'surf_vulcao', name: 'surf_vulcao', tier: 2, stages: 3, authorMs: 65000,
    env: 'lava', hazard: 'lava', sortOrder: 4,
  },
  {
    slug: 'surf_zenite', name: 'surf_zenite', tier: 3, stages: 3, authorMs: 60000,
    env: 'space', hazard: 'void', sortOrder: 5,
  },
];

export function mapMeta(slug: string): MapMeta {
  const m = MAPS_META.find((x) => x.slug === slug);
  if (!m) throw new Error(`mapa desconhecido: ${slug}`);
  return m;
}

export function mapMedals(slug: string): MedalTimes {
  return deriveMedals(mapMeta(slug).authorMs);
}
